import type { EnvLike } from "@atomic/app-shell";

/**
 * The app's `import.meta.env` as the shell reads it (`readAppConfig`). One
 * LMNT spelling is aliased: local dev names the gateway `VITE_BACKENDGATEWAY_URL`
 * (.env.defaults, the VITE_DEV_GATEWAY_PROXY recipe in vite.config.ts), while
 * the shell's contract spells it `VITE_BACKEND_GATEWAY_URL`. Deployed builds
 * set `VITE_HTTP_API_V2_HOST`, which both read the same way. Imported by
 * main.tsx and by the Apollo client, so the two never disagree on the URL.
 */
export const APP_ENV: EnvLike = {
  ...import.meta.env,
  VITE_BACKEND_GATEWAY_URL:
    import.meta.env.VITE_BACKEND_GATEWAY_URL ?? import.meta.env.VITE_BACKENDGATEWAY_URL,
};
